// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EAVRQ0SLBlQrwI {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.EAVRQ0SLBlQrwI:focus-within {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .EAVRQ0SLBlQrwI:focus-within {
  outline-color: -webkit-focus-ring-color;
}
.EAVRQ0SLBlQrwI:focus-within .mac.firefox {
  outline-color: AccentColor;
}
.EAVRQ0SLBlQrwI > a {
  display: block;
  height: 100%;
  text-decoration: none;
}
.qrTPKJDErXrl2J {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.EAVRQ0SLBlQrwI:hover .MAZAn6WpFmeGh0 {
  background-color: hsla(0, 0%, 0%, 0.25);
}
.EAVRQ0SLBlQrwI:hover .M8FZFyLmUhrt6F {
  background-color: hsla(0, 0%, 0%, 0.4);
}
.Iytexbc0IrQBS2 {
  height: 72px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
}
.jKBWU1uXSMBpHL {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  gap: var(--ds-space-100, 8px);
}
.e0Rn4M8yiTn_zc {
  display: block;
  position: absolute;
  top: var(--ds-space-100, 8px);
  left: var(--ds-space-100, 8px);
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: hsla(0, 0%, 0%, 0.25);
}
.e0Rn4M8yiTn_zc::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-background-information-bold, #0c66e4);
}
.KShmLmpSbELmbP {
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-100, 8px);
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 11px;
  font-weight: var(--ds-font-weight-bold, 700);
  line-height: 16px;
  text-transform: uppercase;
}
.IvIyWgWlA49xnf {
  --ds-icon: #ffffff;
  display: flex;
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  overflow: hidden;
  transform: translateX(150%);
  transition: transform 0.2s ease-in-out 0.2s;
  border-radius: var(--ds-border-radius-200, 6px);
  background-color: hsla(0, 0%, 0%, 0.25);
}
.IvIyWgWlA49xnf.pZAivs8_8yYSWn {
  transform: translateX(0);
}
.IvIyWgWlA49xnf button {
  width: 100%;
  height: 100%;
  border-radius: var(--ds-border-radius-200, 6px);
}
.EAVRQ0SLBlQrwI:hover .IvIyWgWlA49xnf,
.EAVRQ0SLBlQrwI:focus-within .IvIyWgWlA49xnf {
  transform: translateX(0);
}
.EGjNp3D4jt2GM7 {
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  flex: 1;
  width: 100%;
}
.bX3Md81Lu50QXR {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: var(--ds-space-100, 8px);
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
  word-wrap: break-word;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `EAVRQ0SLBlQrwI`,
	"boardDetails": `qrTPKJDErXrl2J`,
	"dark": `MAZAn6WpFmeGh0`,
	"light": `M8FZFyLmUhrt6F`,
	"background": `Iytexbc0IrQBS2`,
	"badges": `jKBWU1uXSMBpHL`,
	"activityIndicator": `e0Rn4M8yiTn_zc`,
	"templateLozenge": `KShmLmpSbELmbP`,
	"starContainer": `IvIyWgWlA49xnf`,
	"isStarred": `pZAivs8_8yYSWn`,
	"boardNameContainer": `EGjNp3D4jt2GM7`,
	"boardName": `bX3Md81Lu50QXR`
};
export default ___CSS_LOADER_EXPORT___;
